<template>
  <div
    :class="mergedClasses"
    v-bind="passthroughAttrs"
  >
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HdCardBody',

  inheritAttrs: false,

  emits: [],

  computed: {
    mergedClasses() {
      return [this.$attrs.class, 'card-body'].flat().filter(Boolean);
    },

    passthroughAttrs() {
      const { class: _class, ...attrs } = this.$attrs;

      return attrs;
    }
  }
});
</script>
